<div class="row">
    <div class="col-12">
        <h3>Form Closed</h3>
        <p>You have Closed the form, your response has not been saved.</p>
        <p>
            You can access the form again via the link in the original email you
            received.
        </p>
        <br />
        <p>Please Close this tab to exit</p>
        <p>
            If you should have access to this site, please click
            <a class="btn-link" [routerLink]="['/login']">here</a> to log in
        </p>
    </div>
</div>
